import PropTypes from 'prop-types';
import {REASONS, VISIT_STATUS_LABELS} from '../../config';

export const visit = PropTypes.shape({
  id: PropTypes.number.isRequired,
  status: PropTypes.oneOf(VISIT_STATUS_LABELS.map(v => v.id)).isRequired,
  get_status_display: PropTypes.string,
  visit_reason: PropTypes.oneOf(Object.values(REASONS)).isRequired,
  community: PropTypes.object,
  company: PropTypes.object,
  intervention_zone: PropTypes.number
});